// extracted by mini-css-extract-plugin
module.exports = {"icon":"Uploader_icon__3v9T8","uploader":"Uploader_uploader__2X182","plus":"Uploader_plus__2vMPI"};